module.exports = __webpack_public_path__ + "static/media/thumbnail.938096de.jpg";